export type Role = 'Nephrologist' | 'GP' | 'Nurse'

export interface OptionData {
  id: string
  text: string
  distributions: Record<Role, number>
}

export interface QuestionData {
  id: string
  question: string
  options: OptionData[]
  feedbackHeadline: string
  feedbackBody: string
}

export const surveyData: QuestionData[] = [
  {
    id: 'q1',
    question: 'When do you escalate beyond RAAS blockade?',
    feedbackHeadline: 'No clear consensus on timing',
    feedbackBody:
      'Responses are widely distributed — timing of escalation varies significantly.',
    options: [
      {
        id: 'q1_1',
        text: 'Persistent proteinuria >1g/day',
        distributions: { Nephrologist: 45, GP: 20, Nurse: 30 },
      },
      {
        id: 'q1_2',
        text: 'Declining eGFR',
        distributions: { Nephrologist: 35, GP: 50, Nurse: 40 },
      },
      {
        id: 'q1_3',
        text: 'High-risk at diagnosis',
        distributions: { Nephrologist: 15, GP: 10, Nurse: 15 },
      },
      {
        id: 'q1_4',
        text: 'Case-by-case',
        distributions: { Nephrologist: 5, GP: 20, Nurse: 15 },
      },
    ],
  },
  {
    id: 'q2',
    question: 'What is your primary goal in early IgAN?',
    feedbackHeadline: 'Treatment priorities differ',
    feedbackBody:
      'Clinicians prioritize different endpoints depending on interpretation and experience.',
    options: [
      {
        id: 'q2_1',
        text: 'Reduce proteinuria',
        distributions: { Nephrologist: 50, GP: 30, Nurse: 40 },
      },
      {
        id: 'q2_2',
        text: 'Preserve eGFR',
        distributions: { Nephrologist: 30, GP: 45, Nurse: 35 },
      },
      {
        id: 'q2_3',
        text: 'Control inflammation',
        distributions: { Nephrologist: 15, GP: 10, Nurse: 15 },
      },
      {
        id: 'q2_4',
        text: 'Delay progression',
        distributions: { Nephrologist: 5, GP: 15, Nurse: 10 },
      },
    ],
  },
  {
    id: 'q3',
    question: 'Which mechanisms must be addressed?',
    feedbackHeadline: 'Different views on disease drivers',
    feedbackBody:
      'There is no single dominant view on what drives progression.',
    options: [
      {
        id: 'q3_1',
        text: 'Hemodynamic (RAAS)',
        distributions: { Nephrologist: 25, GP: 40, Nurse: 30 },
      },
      {
        id: 'q3_2',
        text: 'Inflammatory',
        distributions: { Nephrologist: 35, GP: 20, Nurse: 25 },
      },
      {
        id: 'q3_3',
        text: 'Fibrotic',
        distributions: { Nephrologist: 10, GP: 15, Nurse: 15 },
      },
      {
        id: 'q3_4',
        text: 'Combination',
        distributions: { Nephrologist: 30, GP: 25, Nurse: 30 },
      },
    ],
  },
  {
    id: 'q4',
    question: 'How confident are you in current strategies?',
    feedbackHeadline: 'Confidence is mixed',
    feedbackBody:
      'A notable proportion express uncertainty in long-term disease control.',
    options: [
      {
        id: 'q4_1',
        text: 'Very confident',
        distributions: { Nephrologist: 20, GP: 10, Nurse: 15 },
      },
      {
        id: 'q4_2',
        text: 'Somewhat confident',
        distributions: { Nephrologist: 45, GP: 40, Nurse: 50 },
      },
      {
        id: 'q4_3',
        text: 'Not confident',
        distributions: { Nephrologist: 25, GP: 30, Nurse: 20 },
      },
      {
        id: 'q4_4',
        text: 'Unsure',
        distributions: { Nephrologist: 10, GP: 20, Nurse: 15 },
      },
    ],
  },
]
